import React, { useContext, useEffect, Fragment, useState } from "react";
import VideoContext from "../../context/video/videoContext";
import Spinner from "../layouts/Spinner";
import CollectionVideo from "./CollectionVideo.js";
import CollectionNote from "./CollectionNote";
import CollectionLec from "./CollectionLec";
import "../../styles/fonts.css";
import "../../styles/index.css";
import SubjectList from "../editprofs/SubjectList";
import CollectionProf from "./CollectionProf";
const Collection = (props) => {
  const videoContext = useContext(VideoContext);
  const [sub, setSub] = useState("");
  const { videos, getVideos, clearVideos } = videoContext;
  let type = props.match.params.collection;
  let collection = props.location.pathname.split("/")[1];
  useEffect(() => {
    window.scrollTo(0, 0);

    clearVideos();
    if (collection === "youtube") {
      getVideos({
        collection: [collection],
      });
    } else {
      getVideos({
        collection: [collection],
        type,
      });
    }
    console.log(videos);
    //eslint-disable-next-line
  }, [type, collection]);
  return (
    <Fragment>
      {type === "profs" && (
        <>
          <br></br>
          <div class='card border-danger mb-3'>
            <div class='card-body'>
              <h4 class='card-title fontcool'>Please Note:</h4>
              <p class='card-text simplefont'>
                In this page we have collected the videos sent to us via email
                in order of them being conducted. These are the same videos as
                in the email attachments and we do not own any of these. You
                will not be able to view these if{" "}
                <ul>
                  <li>You have not been emailed the video lectures</li>
                  <li>
                    You are not logged in to you iiti email in this browswer, or
                    are browsing in incognito mode.
                  </li>
                </ul>
              </p>
              <hr></hr>
              <strong className="simplefont">
                We feel that the live online lectures are the best means for
                understanding the topics, and would encourage all to attend them
                in the first place, but if they are unable, we have collected
                the videos here for their reference.
              </strong>
            </div>
          </div>

          <SubjectList setSub={setSub} />
        </>
      )}

      {type === "profs" && sub ? (
        <CollectionProf prof={sub} />
      ) : videos && videos[collection] ? (
        <div className='row d-flex justify-content-around p-2'>
          {videos[collection].map((item, index) =>
            type === "videos" || type === "youtube" ? (
              <CollectionVideo key={item.id} video={item} coll={collection} />
            ) : type === "profs" ? (
              <CollectionLec key={item.id} prof={item} />
            ) : (
              <CollectionNote key={item.id} note={item} coll={collection} />
            )
          )}
        </div>
      ) : (
        <Spinner />
      )}
    </Fragment>
  );
};

export default Collection;
